<div class="offcanvas offcanvas-end" tabindex="-1" id="detail-sports"
  aria-labelledby="offcanvasRightLabel">
  <ng-container *ngIf="DetailSports">
    <div class="offcanvas-header">
      <h5 id="offcanvasRightLabel">[{{DetailSports.gameProvider}}] Bill</h5>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body" [ngClass]="{'text-decoration-line-through': DetailSports.gameResult == 'CANCEL'}">
      เลขตั๋ว : {{DetailSports.betId}} <br>
      GAME ID : {{DetailSports.gameBetId}}<br>
      Bet Date/Time : {{DetailSports.timeBet | date:'dd/MM/yyyy HH:mm'}} <br>
      Settle Date/Time : {{DetailSports.timeSettle | date:'dd/MM/yyyy HH:mm'}} <br>
      Type : {{DetailSports.gameSportsType}}<br>
      <hr>
      <div class="table-responsive">
        <table class="table table-hover text-nowrap">
          <thead>
            <tr>
              <th>ลำดับ</th>
              <th>รายละเอียด</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of DetailSports.winlose_detail_sports;let i = index">
              <td>
                {{i+1}}
              </td>
              <td class="text-start">
                <div class="text-start">
                  <span class="d-block-inline border px-3 py-1 bg-se"
                    [ngClass]="{'text-decoration-line-through': DetailSports.gameResult == 'CANCEL'}">
                    <i class="bi bi-trophy"></i> League : {{data.league || 'no league'}}
                  </span>
                </div>
                <div class=" border-start ">
                  <span class="ps-2 text-primary"
                    [ngClass]="{'text-decoration-line-through': DetailSports.gameResult == 'CANCEL'}">
                    H : {{data.match.split(' vs ')[0]}}
                  </span>
                  <div class="ps-2">-vs-</div>
                  <span class="ps-2 text-danger"
                    [ngClass]="{'text-decoration-line-through': DetailSports.gameResult == 'CANCEL'}">
                    A : {{data.match.split(' vs ')[1]}}
                  </span>
                </div>
                <div>KickOff Time : {{data.kickOffTime|date:'dd/MM HH:mm:ss'}} </div>
                <div>Live Score : {{data.liveScore}} </div>
                <div class="text-uppercase">
                  Bet :
                  <span
                    [ngClass]="{'text-primary' : data.match.split(' vs ')[0] == data.betOption,'text-danger' : data.match.split(' vs ')[1] == data.betOption}">
                    {{data.betOption}}
                  </span>
                </div>
                <div>Bet Type : {{data.marketType}} </div>
                <div class="ff-number text-underline">
                  <strong>{{data.hdp}}</strong> @
                  <strong>{{data.odds}}</strong></div>
                <div>
                  Status :
                  <span
                    [ngClass]="{'text-success':data.status.toUpperCase().startsWith('W') , 'text-danger':data.status.toUpperCase().startsWith('L')}">
                    {{data.status.toUpperCase()}}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr>
      <div class="d-flex">
        <span class="w-50">Bet Amount</span>
        <span class="w-50 text-end">{{DetailSports.betAmt | number : '.2-2'}} THB</span>
      </div>
      <div class="d-flex">
        <span class="w-50">Discount</span>
        <span class="w-50 text-end">0.00 THB</span>
      </div>
      <div class="d-flex">
        <span class="w-50"> Odds ({{DetailSports.gameOddsStyle}})</span>
        <span class="w-50 text-end">{{DetailSports.gameOdds}} THB</span>
      </div>
      <div class="d-flex">
        <span class="w-50">Status</span>
        <span class="w-50 text-end">
          <ng-container *ngIf="DetailSports.gameStatus === 'done'">
            <span *ngIf="DetailSports.gameResult === 'win' || DetailSports.gameResult === 'won'">
              WIN
            </span>
            <span
              *ngIf="DetailSports.gameResult === 'los' || DetailSports.gameResult === 'lose' || DetailSports.gameResult === 'loss'">
              LOSE
            </span>
            <span class="text-uppercase" *ngIf="DetailSports.gameResult === 'draw'">
              {{DetailSports.gameResult}}
            </span>
          </ng-container>
          <ng-container *ngIf="DetailSports.gameStatus !== 'done'">
            <span>RUNNING</span>
          </ng-container>
        </span>
      </div>
      <hr>
      <div class="d-flex">
        <span class="w-50">Total</span>
        <span class="w-50 text-end text-underline">{{DetailSports.winLose}} THB</span>
      </div>
    </div>
  </ng-container>
</div>
